// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadDetails_card__2NWPs"};